var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanvaFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1538 5.63637H12.3819L9.23077 2.53296C9.05996 2.36339 8.85663 2.22896 8.6326 2.13746C8.40856 2.04597 8.1683 1.99925 7.92577 2.00001H1.84615C1.35652 2.00001 0.886947 2.19157 0.540726 2.53254C0.194505 2.87352 0 3.33598 0 3.81819V20.2523C0.000610604 20.7156 0.187774 21.1598 0.520447 21.4874C0.85312 21.8151 1.30415 21.9994 1.77462 22H22.2565C22.7187 21.9994 23.1618 21.8183 23.4887 21.4964C23.8155 21.1745 23.9994 20.7382 24 20.283V7.45455C24 6.97234 23.8055 6.50988 23.4593 6.1689C23.1131 5.82793 22.6435 5.63637 22.1538 5.63637ZM1.84615 3.81819H7.92577L9.77192 5.63637H1.84615V3.81819ZM22.1538 20.1818H1.84615V7.45455H22.1538V20.1818Z",
    fill: "#696869"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvaFolder);
export default __webpack_public_path__ + "static/media/canva-folder.2c201722be3e97bb3bebf6015fce1374.svg";
export { ForwardRef as ReactComponent };